module.exports = __webpack_public_path__ + "static/img/turismo_category.7c69784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turismo_category.jpg
// module id = WmX+
// module chunks = 1